import React, { Component } from 'react';

import { connect } from 'react-redux';

import '../styles/QuizStats.css';

class QuizStats extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const { totalAnswered, totalCorrect, isCorrect, answered, test, finished } = this.props;

    return (
      <div className={`${this.props.visible ? '' : 'hide '}stats-score-box${this.props.test && !this.props.finished ? ' test-hide' : ' not-test-score'}`}>
        <p className="stats-score-text">SESSION SCORE</p>
        <p style={answered && (!test || finished) ? isCorrect ? { fontWeight: '900', color: '#95BF5E' } : { fontWeight: '900', color: '#FF7065' } : null} className="stats-score-percent">{(!test || finished) ? (totalAnswered ? Math.floor((totalCorrect / totalAnswered) * 100).toFixed() : 0) : '-'}<span>%</span></p>
        <div className={`arrow-inner${this.props.arrow ? '' : ' hide-arrow'}`} />
        <div className={`arrow-outer${this.props.arrow ? '' : ' hide-arrow'}`} />
      </div>);
  }
}

function mapStateToProps(state) {
  const question = state.quiz.questions[state.quiz.currentQuestionIndex];

  return {
    totalAnswered: state.quiz.questions.reduce((total, _question) => total + (_question.answered ? 1 : 0), 0),
    totalCorrect: state.quiz.questions.reduce((total, _question) => total + ((_question.answered && _question.options[_question.selectedOptionIndex].correctOption) ? 1 : 0), 0),
    isCorrect: question.selectedOptionIndex >= 0 && question.options[question.selectedOptionIndex].correctOption,
    answered: question.answered,
    test: state.quiz.mode === 1,
    finished: state.quiz.questions.reduce((total, question) => total + (question.answered ? 1 : 0), 0) === state.quiz.questions.length,
  };
}

export default connect(mapStateToProps, null)(QuizStats);

// QuestionCountProgress.propTypes = {
//   completed: React.PropTypes.bool.isRequired,
// };



// WEBPACK FOOTER //
// ./src/containers/QuizStats.js